import Vue from 'vue'
import Router from 'vue-router'
import lazy from '@lib/router/lazy'
import store from './state/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      // component: () => lazy(import('./views/dashboard')),
      // meta: {
      //   menu: 'dashboard',
      // },
      redirect: {
        name: 'providers',
      },
    },
    {
      path: '/providers',
      name: 'providers',
      component: () => lazy(import('./views/providers')),
      meta: {
        menu: 'providers',
        scopes: ['provider:search'],
      },
    },
    {
      path: '/providers/:id/:tab?',
      name: 'provider-details',
      component: () => lazy(import('./views/provider')),
      meta: {
        menu: 'providers',
        scopes: ['provider:read'],
      },
      props: true,
    },
    {
      path: '/provider-products',
      name: 'provider-products',
      component: () => lazy(import('./views/provider-products')),
      meta: {
        menu: 'provider-products',
        scopes: ['provider_product:search'],
      },
    },
    {
      path: '/provider-product/:providerId/:providerProductId',
      name: 'provider-product',
      component: () => lazy(import('./views/provider-product')),
      meta: {
        menu: 'provider-products',
        scopes: ['provider_product:read'],
      },
      props: true,
    },
    {
      path: '/provider-product/edit/:providerId/:providerProductId/:step?',
      name: 'provider-product-edit',
      // Do not use lazy(import('./views...')) in order to have access to beforeRouteLeave guard
      component: () => import('./views/provider-product/provider-product-form'),
      props: true,
      meta: {
        skipFromBackButton: true,
        menu: 'provider-products',
        scopes: ['provider_product:update', 'product_template:read'],
      },
    },
    // routes below might be eliminated later on
    // {
    //   path: '/provider-product/:id/edit',
    //   name: 'provider-product-edit',
    //   component: () => lazy(import('./views/provider-product/edit-provider-product.vue')),
    //   redirect: {
    //     name: 'provider-product-edit-product',
    //   },
    //   children: [
    //     {
    //       path: 'product',
    //       name: 'provider-product-edit-product',
    //       component: () => lazy(import('./views/provider-product/edit/product.vue')),
    //       props: true,
    //     },
    //     {
    //       path: 'price',
    //       name: 'provider-product-edit-price',
    //       component: () => lazy(import('./views/provider-product/edit/price.vue')),
    //       props: true,
    //     },
    //     {
    //       path: 'dimensions',
    //       name: 'provider-product-edit-dimensions',
    //       component: () => lazy(import('./views/provider-product/edit/dimensions.vue')),
    //       props: true,
    //     },
    //     {
    //       path: 'shipping',
    //       name: 'provider-product-edit-shipping',
    //       component: () => lazy(import('./views/provider-product/edit/shipping.vue')),
    //       props: true,
    //     },
    //   ],
    // },
    {
      path: '/suppliers',
      name: 'suppliers',
      component: () => lazy(import('./views/suppliers')),
      meta: {
        menu: 'suppliers',
        scopes: ['supplier:search'],
      },
    },
    {
      path: '/suppliers/:id/:tab?',
      name: 'supplier-details',
      component: () => lazy(import('./views/supplier')),
      meta: {
        menu: 'suppliers',
        scopes: ['supplier:read'],
      },
    },
    {
      path: '/supplier-product/:supplierId/:sku',
      name: 'supplier-product',
      component: () => lazy(import('./views/supplier-product')),
      props: true,
      meta: {
        menu: 'supplier-products',
        scopes: ['supplier_product:read'],
      },
    },
    {
      path: '/supplier-product/create/:supplierId/:step?',
      name: 'supplier-create-product',
      component: () => import('./views/supplier-product/supplier-product-form'),
      props: true,
      meta: {
        skipFromBackButton: true,
        menu: 'suppliers',
        scopes: ['supplier_product_template:read'],
      },
    },
    {
      path: '/supplier-product/edit/:supplierId/:sku/:step?',
      name: 'supplier-product-edit',
      // Do not use lazy(import('./views...')) in order to have access to beforeRouteLeave guard
      component: () => import('./views/supplier-product/supplier-product-form'),
      props: route => ({ ...route.params, isEdit: true }),
      meta: {
        skipFromBackButton: true,
        menu: 'supplier-products',
        scopes: ['supplier_product_template:read'],
      },
    },
    {
      path: '/supplier-products',
      name: 'supplier-products',
      component: () => lazy(import('./views/supplier-products')),
      meta: {
        menu: 'supplier-products',
        scopes: ['supplier_product:search'],
      },
    },
    {
      path: '/contracts',
      name: 'contracts',
      component: () => lazy(import('./views/contracts')),
      meta: {
        menu: 'contracts',
        scopes: ['contract:search'],
      },
    },
    {
      path: '/contracts/:id/:tab?',
      name: 'contract-details',
      component: () => lazy(import('./views/contract')),
      props: true,
      meta: {
        menu: 'contracts',
        scopes: ['contract:read'],
      },
    },
    {
      path: '/product-category-trees',
      name: 'product-category-trees',
      component: () => lazy(import('./views/product-category-trees')),
      meta: {
        menu: 'product-category-trees',
        scopes: ['category_tree:search'],
      },
    },
    {
      path: '/product-category-trees/:id',
      name: 'product-category-tree',
      component: () => lazy(import('./views/product-category-tree')),
      props: true,
      meta: {
        menu: 'product-category-trees',
        scopes: ['category_tree:read'],
      },
    },
    {
      path: '/category-hierarchy/:id?',
      name: 'category-hierarchy',
      // Do not use lazy(import('./views...')) in order to have access to beforeRouteLeave guard
      component: () => import('./views/category-hierarchy'),
      props: true,
      meta: {
        menu: 'product-category-trees',
        scopes: ['category_tree:update', 'category_tree:create'],
      },
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => lazy(import('./views/orders')),
      meta: {
        menu: 'orders',
        scopes: ['order:search'],
      },
    },
    {
      path: '/orders/:orderId',
      name: 'order-details',
      component: () => lazy(import('./views/order')),
      props: true,
      meta: {
        menu: 'orders',
        scopes: ['order:read'],
      },
    },
    {
      path: '/order-items',
      name: 'order-items',
      component: () => lazy(import('./views/order-items')),
      meta: {
        menu: 'order-items',
        scopes: ['order_items:search'],
      },
    },
    {
      path: '/order-items/:orderId/:itemId',
      name: 'order-item-details',
      component: () => lazy(import('./views/order-item')),
      props: true,
      meta: {
        menu: 'orders-items',
        scopes: ['order_items:read'],
      },
    },
    {
      path: '/publish/:id/:tab?',
      name: 'publish-details',
      component: () => lazy(import('./views/publishing')),
      props: true,
      meta: {
        menu: 'providers',
      },
    },
    {
      path: '*',
      redirect: '/',
    },
    {
      path: '/api-keys',
      name: 'api-keys',
      component: () => lazy(import('./views/api-keys')),
      meta: {
        menu: 'api-keys',
        scopes: ['api_key:read'],
      },
    },
    {
      path: '/api-key/create',
      name: 'api-key-create',
      component: () => import('./views/api-key/api-key-form.vue'),
      props: true,
      meta: {
        skipFromBackButton: true,
        menu: 'api-keys',
        scopes: ['api_key:create'],
      },
    },
    {
      path: '/api-key/:id/',
      name: 'api-key',
      component: () => lazy(import('./views/api-key/api-key-details.vue')),
      props: true,
      meta: {
        menu: 'api-keys',
        scopes: ['api_key:read'],
      },
    },
    {
      path: '/api-key/:id/edit',
      name: 'api-key-edit',
      component: () => import('./views/api-key/api-key-form.vue'),
      props: true,
      meta: {
        skipFromBackButton: true,
        menu: 'api-keys',
        edit: true,
        scopes: ['api_key:update'],
      },
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  if (!store.state.auth.accessToken) {
    return next()
  }

  to.params.from = from

  const { scopes } = to.meta
  // await until scopes are loaded
  await store.state.me.loadedPromise

  if (scopes) {
    // check if current user have all required scopes
    if (!scopes.some(store.getters['me/hasPermission'])) {
      if (to.name === 'providers') {
        const providerId = store.getters['me/meProviderId']
        const supplierId = store.getters['me/meSupplierId']

        if (providerId && store.getters['me/canReadProvider']) {
          return next({
            name: 'provider-details',
            params: {
              id: providerId,
            },
          })
        } else if (store.getters['me/canSearchSupplier']) {
          return next({ name: 'suppliers' })
        } else if (supplierId && store.getters['me/canReadSupplier']) {
          return next({
            name: 'supplier-details',
            params: {
              id: supplierId,
            },
          })
        }
      }

      return next({ name: '404' })
    }

    if (to.name === 'supplier-product') {
      // Dynamically change parent menu if role is estore:provider_admin for ui consistency
      to.meta.menu = store.getters['me/canSearchSupplierProduct'] ? 'supplier-products' : 'provider-products'
    }
  }

  store.commit('providers/SET_PROVIDERS_LIST', [])
  next()
})

export default router
